import { createApp } from 'vue'
import Root from '@/views/root.vue'

export class VueModel {
    vm: any
    constructor() {
        this.vm = createApp(Root)
        this.vm.config.errorHandler = (err: any, vm: any, info: any): void => {
            // 处理错误
            // `info` 是 Vue 特定的错误信息，比如错误所在的生命周期钩子
            console.log('------- error info --------')
            console.log(err, info)
            console.log('------- error info --------')
        }
    }
    getVue() {
        return this.vm
    }
}

export let vm = new VueModel().getVue()